export const yogaCategories = {
  category: 'Yoga',
  classFinderLink: '/class-finder?styles=yoga&order=date&from=nav',
  subcategories: [
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Ashtanga.jpg',
      title: 'Ashtanga',
      url: '/class-finder?styles=yoga_ashtanga&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Hatha.jpg',
      title: 'Hatha',
      url: '/class-finder?styles=yoga_hatha&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Kundalini.jpg',
      title: 'Kundalini',
      url: '/class-finder?styles=yoga_kundalini&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Prenatal.jpg',
      title: 'Prenatal/Postnatal',
      url: '/class-finder?styles=yoga_prenatal-postnatal&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Restorative.jpg',
      title: 'Restorative',
      url: '/class-finder?styles=yoga_restorative&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Vinyasa.jpg',
      title: 'Vinyasa',
      url: '/class-finder?styles=yoga_vinyasa&order=date&from=nav'
    }
  ]
}

export const fitnessCategories = {
  category: 'Fitness',
  classFinderLink: '/class-finder?styles=fitness&order=date&from=nav',
  subcategories: [
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Barre.jpg',
      title: 'Barre',
      url: '/class-finder?styles=fitness_barre&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Core.jpg',
      title: 'Core',
      url: '/class-finder?styles=fitness_core&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Dance.jpg',
      title: 'Dance',
      url: '/class-finder?styles=fitness_dance&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Gym.jpg',
      title: 'Gym',
      url: '/class-finder?styles=fitness_gym&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_HIIT.jpg',
      title: 'HIIT',
      url: '/class-finder?styles=fitness_hiit&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Pilates.jpg',
      title: 'Pilates',
      url: '/class-finder?styles=fitness_pilates&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/yoga/HP-Img-Update_Yoga_Prenatal.jpg',
      title: 'Prenatal/Postnatal',
      url: '/class-finder?styles=fitness_prenatal-postnatal&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Running.jpg',
      title: 'Running',
      url: '/class-finder?styles=fitness_running&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Sculpt.jpg',
      title: 'Sculpt',
      url: '/class-finder?styles=fitness_sculpt&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Strength.jpg',
      title: 'Strength',
      url: '/class-finder?styles=fitness_strength&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Stretching.jpg',
      title: 'Stretching',
      url: '/class-finder?styles=fitness_stretching&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/fitness/HP-Img-Update_Fitness_Walking.jpg',
      title: 'Walking',
      url: '/class-finder?styles=fitness_walking&order=date&from=nav'
    }
  ]
}

export const mindfulnessCategories = {
  category: 'Mindfulness',
  classFinderLink: '/class-finder?styles=mindfulness&order=date&from=nav',
  subcategories: [
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/mindfulness/HP-Img-Update_Mindfulness_Breathwork.jpg',
      title: 'Breathwork',
      url: '/class-finder?styles=mindfulness_breathwork&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/mindfulness/HP-Img-Update_Mindfulness_Meditation.jpg',
      title: 'Meditation',
      url: '/class-finder?styles=mindfulness_meditation&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/mindfulness/HP-Img-Update_Mindfulness_Reiki.jpg',
      title: 'Reiki',
      url: '/class-finder?styles=mindfulness_reiki&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/mindfulness/HP-Img-Update_Mindfulness_Sound.jpg',
      title: 'Sound',
      url: '/class-finder?styles=mindfulness_sound&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/mindfulness/HP-Img-Update_Mindfulness_Yoga+Nidra.jpg',
      title: 'Yoga Nidra',
      url: '/class-finder?styles=mindfulness_yoga-nidra&order=date&from=nav'
    }
  ]
}

export const wellnessCategories = {
  category: 'Wellness',
  classFinderLink: '/class-finder?styles=wellness&order=date&from=nav',
  subcategories: [
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/wellness/CycleSyncing.jpg',
      title: 'Cycle Syncing',
      url: '/class-finder?styles=wellness_cycle-syncing&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/wellness/Nutrition.jpeg',
      title: 'Nutrition',
      url: '/class-finder?styles=wellness_nutrition&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/wellness/Personal-Growth.jpg',
      title: 'Personal Growth',
      url: '/class-finder?styles=wellness_personal-growth&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/wellness/SelfCare.jpg',
      title: 'Self-Care',
      url: '/class-finder?styles=wellness_self-care&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/wellness/Sleep.jpg',
      title: 'Sleep',
      url: '/class-finder?styles=wellness_sleep&order=date&from=nav'
    }
  ]
}

export const skillsCategories = {
  category: 'Skills',
  classFinderLink: '/class-finder?styles=skills&order=date&from=nav',
  subcategories: [
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Arm-Balances.jpg',
      title: 'Arm Balances',
      url: '/class-finder?styles=skills_arm-balances&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Backbends.jpg',
      title: 'Backbends',
      url: '/class-finder?styles=skills_backbends&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Flexibility.jpg',
      title: 'Flexibility',
      url: '/class-finder?styles=skills_flexibility&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__How-To-Teach.jpg',
      title: 'How to Teach',
      url: '/class-finder?styles=skills_how-to-teach&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Inversion.jpg',
      title: 'Inversions',
      url: '/class-finder?styles=skills_inversions&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Mobility.jpg',
      title: 'Mobility',
      url: '/class-finder?styles=skills_mobility&order=date&from=nav'
    },
    {
      image:
        'https://alomoves.s3.amazonaws.com/manual_uploads/shared/navigation/categories/skills/HP-Img-Update_Skills__Yoga-Poses.jpg',
      title: 'Yoga Poses',
      url: '/class-finder?styles=skills_yoga-poses&order=date&from=nav'
    }
  ]
}

export const difficultyClasses = {
  title: 'Difficulty',
  links: [
    {
      label: 'Introductory',
      url: '/class-finder?difficulties=introductory&order=date&from=nav'
    },
    {
      label: 'Beginner',
      url: '/class-finder?difficulties=beginner&order=date&from=nav'
    },
    {
      label: 'Moderate',
      url: '/class-finder?difficulties=moderate&order=date&from=nav'
    },
    {
      label: 'Intermediate',
      url: '/class-finder?difficulties=intermediate&order=date&from=nav'
    },
    {
      label: 'Advanced',
      url: '/class-finder?difficulties=advanced&order=date&from=nav'
    }
  ]
}
